import React, {
  FC,
  MouseEvent,
  PropsWithChildren,
  ComponentProps,
} from 'react';
import Button from 'react-bootstrap/Button';

type Props = Omit<ComponentProps<typeof Button>, 'variant'> & {
  action?: (event: MouseEvent) => void;
  classes?: string;
  variant?: string;
};

/**
 * A square button mainly for use in the List component
 *
 * Wraps its children in a bootstrap button
 */
const ListItem: FC<PropsWithChildren<Props>> = ({
  children,
  action,
  classes = '',
  variant,
  ...bttnProps
}) => {
  return (
    <Button
      className={`button-item ${classes}`}
      {...bttnProps}
      // @ts-ignore
      variant={variant}
      onClick={event => action && action(event)}
    >
      {children}
    </Button>
  );
};

export default ListItem;
